import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { L10n } from "@syncfusion/ej2-base";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  ColumnsDirective,
  ColumnDirective,
  Page,
  Toolbar,
  Edit,
  Inject,
  Filter,
  VirtualScroll,
  Sort,
  DetailRow,
  Selection,
  ColumnChooser,
  Group,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom/client";
import axiosWrapper from "../../../../../services/axiosWrapper";
import css from "./index.module.css";
import { getPortalProfiles } from "../../../../../actions/portalSetting.helper";
import {
  portalUsersService,
  includedProjectsService,
  portalProfilesService,
  inactiveUsersUrl,
  portalCompaniesService,
} from "../../../../../services/dataManager";
import { changePortalRole } from "@Actions/portalSetting";
import Forbidden from "../../../../../pages/Error/Forbidden";
import { showToastNotification } from "../../../../../actions/toast";
import { convertDate } from "../../../../../services/luxonHelper";
import ToolTipComponent from "../../../../../cubeComponent/html/tooltip";
import GridComponent from "../../../../../cubeComponent/html/grid";
import AddUserToPortal from "../../../../AddUserToPortal";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { DeactivateIcon, PlusIcon, EditIcon } from "../../../../StickySidebarViewer/assets/selectionIcons";
import DropDownListComponent from "@CubeComponents/form/DropdownListComponent";
import ModalStateDialogComponent from "../../../../../cubeComponent/html/modal/ModalWithState";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_WARNING } from "../../../../../services/constants";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import UserNameTagComponent from "../../../../../cubeComponent/html/UserNameTagComponent";

function PortalUsersList() {
  const { t } = useTranslation();
  L10n.load({
    "en-US": {
      grid: {
        AddFormTitle: "Create New ",
        EditFormTitle: "Edit  ",
        CancelButton: "Discard",
        ConfirmDelete: "Are you sure you want to Delete ?",
      },
    },
  });

  const dataGrid = useRef();
  const dispatch = useDispatch();
  const { portalSettingInfo, userDetails, profileData } = useSelector((state) => state);
  const [portalRoles, setPortalRoles] = useState([]);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [addEnabled] = useState(true);
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [newProfileData, setNewProfileData] = useState({});
  const [showWarningModal, setShowWarningModal] = useState(false);

  const userStatus = {
    ACTIVE: "",
    INVITED: "Invited",
  };

  const editSettings = {
    allowEditing: false,
    allowAdding: false,
    allowDeleting: false,
    mode: "Dialog",
    showDeleteConfirmDialog: true,
  };

  const pageSettings = { pageSizes: true, pageSize: 10 };

  // call for getting data of portal roles for column portal role
  useEffect(() => {
    dispatch(getPortalProfiles());
  }, []);

  useEffect(() => {
    document.title = t("Portal Settings | Portal Users");
    if (profileData.length > 0) {
      let filteredPortalRole = profileData;
      if (userDetails?.portalRole?.roleName == "PORTAL_SUPER_ADMIN" && userDetails.portalRole.isDefaultRole) {
        setPortalRoles(filteredPortalRole);
      } else {
        filteredPortalRole = filteredPortalRole.filter((item) => item.roleName != "PORTAL_SUPER_ADMIN");
      }
      setPortalRoles(filteredPortalRole);
    }
  }, [profileData]);

  useEffect(() => {
    const permission = portalSettingInfo?.portalUsers;
    if (permission != undefined && permission.isVisible) {
      // NEED TO REMOVE Settimeout in future.
      setTimeout(() => {
        // if (permission.addUser.enable === true) {
        //   grid.childGrid.toolbar[0].disabled = false;
        // }
        // if (permission.addUser.enable === false) {
        //   grid.childGrid.toolbar[0].disabled = true;
        // }
      }, 1000);
    }
  }, [portalSettingInfo]);

  const toolbarClick = (params) => {
    if (params.item.properties.id === "add_user") {
      setOpenAddUserModal(true);
    } else if (params.item.properties.id === "deactivate_user") {
      setOpenDeactivateModal(true);
    } else if (params.item.properties.id === "edit_user") {
      setOpenEditUserModal(true);
    }
  };

  const toolbarChildClickHandler = (params) => {
    const childGrid = params.originalEvent.currentTarget.closest(".e-grid").ej2_instances[0];

    if (params.item.properties.id === "custom_remove_user_from_prj") {
      childGrid.deleteRecord(childGrid.getSelectedRecords());
    }
  };

  const actionChildBegin = (args) => {
    const childGrid = args?.tr?.[0].closest(".e-grid").ej2_instances[0];

    if (args.requestType === "delete" && args.type === "actionBegin") {
      args.cancel = true;
      axiosWrapper
        .post(`${getBackendUrl()}/projects/removeUserFromProject/`, {
          userId: args.data[0].userId,
          resourceId: args.data.map((project) => project.id),
        })
        .then(() => childGrid.refresh());
    }
  };

  const actionBegin = (args) => {
    if (["add", "beginEdit"].includes(args.requestType)) {
      // columnModel.forEach((val) => {
      //   if (
      //     val.field === "createdByName" ||
      //     val.field === "status" ||
      //     val.field === "createdDate" ||
      //     val.field === "sharedWith"
      //   ) {
      //     val.visible = false;
      //   }
      // });
    }
  };

  const selectingChildEvents = (args) => {
    const row = Array.isArray(args.row) ? args.row[0] : args.row;
    const childGrid = row.offsetParent.closest(".e-grid").ej2_instances[0];
    if (childGrid.getSelectedRowIndexes().length >= 1) {
      // childGrid.toolbarModule.enableItems(['custom_remove_user_from_prj'], portalSettingInfo.portalUsers.removeUser.enable);
    } else {
      // childGrid.toolbarModule.enableItems(['custom_remove_user_from_prj'], false);
    }
  };

  const handleChangeUserProfile = (e, args) => {
    dispatch(
      changePortalRole({
        userId: args.data.id,
        roleId: e.target.value,
      }),
    );
  };

  const formatDate = (props) => {
    const dateFormat = convertDate(Number(props.createdDate), "dateForTooltip");
    return (
      <div style={{ width: "fit-content" }}>
        <ToolTipComponent showTipPointer={false} position="bottom" content={dateFormat}>
          <span> {convertDate(Number(props.createdDate), "dateForText")} </span>
        </ToolTipComponent>
      </div>
    );
  };

  const childQueryCellInfo = (args) => {
    if (args.column.field === "createdByName") {
      // ReactDOM.createRoot(args.cell).render(
      //   props.getUserAvatar(args.data.createdBy, args.data.createdByName, args.data.profilePicId),
      // );
    }
  };

  const childGrid = {
    dataSource: includedProjectsService,
    queryString: "userId",
    editSettings,
    // toolbar: childtoolbarOptions,
    allowGrouping: false,
    actionBegin: actionChildBegin,
    toolbarClick: toolbarChildClickHandler,
    rowSelected: selectingChildEvents,
    rowDeselected: selectingChildEvents,
    allowPaging: true,
    pageSettings,
    rowHeight: 48,
    columns: [
      {
        field: "checkbox",
        type: "checkbox",
        headerText: t("Project ID"),
        width: 20,
      },
      { field: "projectId", headerText: t("Project ID"), width: 70 },
      { field: "description", headerText: t("Project Name"), width: 70 },
      {
        field: "createdDate",
        headerText: t("Created On"),
        width: 100,
        template: formatDate,
      },
      { field: "createdByName", headerText: t("Created by"), width: 70 },
      { field: "status", headerText: t("Status"), width: 70 },
      { field: "location", headerText: t("Location"), width: 70 },
    ],
    queryCellInfo: childQueryCellInfo,
  };

  const queryCellInfo = (args) => {
    if (args.column.field === "role") {
      const role = portalRoles?.find((item) => item.id === args.data.roleId);
      const userRole = portalRoles?.find((item) => item.id === userDetails.portalRole.id);
      if (userRole?.name != "PORTAL_SUPER_ADMIN" && role?.name == "PORTAL_SUPER_ADMIN") {
        ReactDOM.createRoot(args.cell).render(<span>{t("Super Admin")}</span>);
      } else if (!args.data.roleId) {
        ReactDOM.createRoot(args.cell).render(<span>{args.data.role}</span>);
      } else {
        ReactDOM.createRoot(args.cell).render(
          <DropDownListComponent
            value={args.data.roleId}
            fields={{ text: "frontendName", value: "id" }}
            dataSource={portalRoles}
            onChange={(e) => handleChangeUserProfile(e, args)}
            enabled={
              portalSettingInfo?.portalUsers?.roleDropdown?.enable &&
              args.data.id != userDetails.id &&
              userDetails.portalRole.isDefaultRole
            }
            buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          />,
        );
      }
    } else if (args.column.field === "created") {
      ReactDOM.createRoot(args.cell).render(convertDate(Number(args.data.created), "dateForText"));
    } else if (args.column.field === "status") {
      ReactDOM.createRoot(args.cell).render(<span>{userStatus[args.data.status]}</span>);
    }
  };

  const addButtonTemplate = () => (
    <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
      <div className={css.gridButtons}>
        <PlusIcon color={addEnabled ? "var(--primary-text)" : "var(--system-colour-37"} />
        <span data-testid="addUsersToPortalBtn">{t("Add")}</span>
      </div>
    </ButtonComponent>
  );

  const editButtonTemplate = () => (
    <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="edit_user">
      <div className={css.gridButtons}>
        <EditIcon color="var(--primary-text)" />
        <span data-testid="editUserBtn">{t("Edit")}</span>
      </div>
    </ButtonComponent>
  );

  const deactivateButtonTemplate = () => (
    <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="deactivate_user">
      <div className={css.gridButtons}>
        <DeactivateIcon />
        <span data-testid="deactivateUserBtn">{t("Deactivate")}</span>
      </div>
    </ButtonComponent>
  );

  const usersRowStateSet = (state) => {
    dataGrid.current?.toolbarModule.enableItems(["deactivate_user"], state);
    dataGrid.current?.toolbarModule.enableItems(["edit_user"], state);
    if (state) {
      setSelectedRow(dataGrid.current.getSelectedRecords()[0]);
    }
  };

  const handleUserDetailsChange = (data) => {
    if (data.value) {
      setNewProfileData((prev) => ({
        ...prev,
        [data.field]: data.value,
      }));
    }
  };

  const warningModal = () => (
    <ModalStateDialogComponent
      padding="var(--size-32)"
      footerContent={
        <div className="flex w-full gap-4">
          <ButtonComponent
            onClick={() => {
              handleEditUser(showWarningModal, true);
            }}
            buttonType="gradientButton"
          >
            Confirm
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleCloseModal(true);
            }}
            buttonType="borderButton"
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      headerTitle="Send Invite & Reset Profile "
      width="30%"
      onCancel={() => {
        handleCloseModal(true);
      }}
      isVisible={showWarningModal}
      modelContent={
        <div className="flex flex-col justify-center mt-2 mb-2 me-2">
          <div className="mb-4 mt-2">
            {t(
              "Since you've updated the email address, a new invitation link will be sent to the email for verification. Are you sure you want to proceed?",
            )}
          </div>
          <div className="mb-4">
            Using the new email address, this user will be able to access all the previously associated data.
          </div>
          <div className="mb-4">
            <b>Note:-</b> All the previous profile information of this user will be reset to default.
          </div>
        </div>
      }
    />
  );

  const editUserModal = () => (
    <ModalStateDialogComponent
      padding="var(--size-32)"
      footerContent={
        <div className="flex w-full mt-2 gap-4">
          <ButtonComponent
            onClick={() => {
              handleEditUser();
            }}
            buttonType="gradientButton"
          >
            {t("Save")}
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleCloseModal();
            }}
            buttonType="borderButton"
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      headerTitle="Edit User Details"
      width="45%"
      onCancel={handleCloseModal}
      isVisible={openEditUserModal}
      modelContent={
        <div id="dsfdgf">
          <div className="flex mt-4">
            Username
            <div className="flex-1" />
            <TextBoxComponent
              placeholder={t("Enter UserName")}
              data-name="userName"
              value={selectedRow.fullName}
              input={(e) => {
                handleUserDetailsChange({ value: e.value, field: "fullName" });
              }}
              width="350px"
              data-testid="userName"
            />
          </div>

          {selectedRow.email && (
            <div className="flex mt-2">
              <div>{t("Email")}</div>
              <div className="flex-1" />
              <TextBoxComponent
                placeholder={t("Enter Email")}
                data-name="email"
                value={selectedRow.email}
                onChange={(e) => {
                  handleUserDetailsChange({ value: e.value, field: "email" });
                }}
                width="350px"
                data-testid="email"
              />
            </div>
          )}

          <div className="flex mt-2">
            <div>{t("User ID")}</div>
            <div className="flex-1" />
            <TextBoxComponent
              placeholder={t("Enter User ID")}
              data-name="userId"
              value={selectedRow.userName}
              onChange={(e) => {
                handleUserDetailsChange({ value: e.value, field: "userName" });
              }}
              width="350px"
              data-testid="userId"
            />
          </div>

          {!selectedRow.email && (
            <div className="flex mt-2">
              <div>{t("Password")}</div>
              <div className="flex-1" />
              <TextBoxComponent
                placeholder={t("Enter Password")}
                data-name="password"
                change={(e) => {
                  handleUserDetailsChange({
                    value: e.value,
                    field: "password",
                  });
                }}
                width="350px"
                data-testid="password"
              />
            </div>
          )}

          <div className="flex  mt-2">
            <div>{t("Org")}</div>
            <div className="flex-1" />
            <DropDownListComponent
              buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON}
              placeholder={t("Select Organization")}
              value={selectedRow.companyId}
              fields={{ text: "name", value: "id" }}
              data-name="id"
              dataSource={portalCompaniesService}
              change={(e) => {
                handleUserDetailsChange({ value: e.value, field: "companyId" });
              }}
              width="350px"
              data-testid="selectOrg"
            />
          </div>

          <div className="flex mt-2 mb-2">
            <div>{t("Role")}</div>
            <div className="flex-1" />
            <DropDownListComponent
              buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON}
              placeholder={t("Select Role")}
              value={selectedRow.roleId}
              data-name="roleId"
              fields={{ text: "frontendName", value: "id" }}
              dataSource={portalProfilesService}
              change={(e) => {
                handleUserDetailsChange({ value: e.value, field: "roleId" });
              }}
              width="350px"
              data-testid="selectRole"
            />
          </div>
        </div>
      }
    />
  );

  const deactivateUserModal = () => (
    <ModalStateDialogComponent
      padding="var(--size-32)"
      footerContent={
        <div className="flex w-full gap-4">
          <ButtonComponent
            onClick={() => {
              handleDeactiveUser();
            }}
            buttonType="gradientButton"
          >
            Confirm
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleCloseModal();
            }}
            buttonType="borderButton"
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      headerTitle="Deactivate User"
      width="30%"
      onCancel={handleCloseModal}
      isVisible={openDeactivateModal}
      modelContent={<div className="mb-5 mt-4">{t("Are you sure you want to deactivate this user?")}</div>}
    />
  );

  const handleEditUser = async (data = newProfileData, skipWarning) => {
    const payload = {
      userId: selectedRow.userId,
      ...data,
    };
    const result = handleValidateDataEdited(data);
    const response = {};
    handleCloseModal(skipWarning);
    if (result) {
      if (result == "email" && !skipWarning) {
        setShowWarningModal(data);
      } else {
        const res = await axiosWrapper.post(`${getBackendUrl()}/accounts/updateUserProfile`, payload);
        if (res.data.status) {
          response.content = res.data.message || "Updated successfully";
        } else {
          response.type = TOAST_TYPE_ERROR;
          response.content = res.data.errorMessage;
        }
      }
    } else {
      response.content = "Please enter new data to proceed.";
      response.type = TOAST_TYPE_WARNING;
    }
    dispatch(showToastNotification(response));
  };

  const handleValidateDataEdited = (data) => {
    let returnStr;
    for (const [field, value] of Object.entries(data)) {
      if (field == "email") {
        if (value.toLowerCase() != selectedRow[field].toLowerCase()) {
          returnStr = field;
          break;
        }
      } else if (field == "userName") {
        if (value.toLowerCase() != selectedRow[field].toLowerCase()) {
          returnStr = field;
          break;
        }
      } else if (value != selectedRow[field]) {
        returnStr = field;
      }
    }
    return returnStr;
  };

  const handleDeactiveUser = async () => {
    handleCloseModal();
    const userData = {
      action: "deactivate",
      data: {
        userId: dataGrid.current.getSelectedRecords()[0].userId,
      },
    };
    const res = await axiosWrapper.post(inactiveUsersUrl, userData);
    const response = {};
    if (res.data.status) {
      response.content = "Deactivated user successfully!";
      dataGrid.current.refresh();
    } else {
      response.content = SOMETHING_WENT_WRONG;
      response.type = TOAST_TYPE_ERROR;
    }
    dispatch(showToastNotification(response));
  };

  const handleCloseModal = (flag) => {
    setOpenDeactivateModal(false);
    setOpenEditUserModal(false);
    setNewProfileData({});
    if (flag) {
      setShowWarningModal(false);
    }
  };

  const toolbarOptions = [
    { id: "add_user", template: addButtonTemplate },
    { id: "edit_user", template: editButtonTemplate, disabled: true },
    {
      id: "deactivate_user",
      template: deactivateButtonTemplate,
      disabled: true,
    },
    {
      text: "ColumnChooser",
      htmlAttributes: { "data-testid": "columnChooserProjectButton" },
    },
  ];

  const getUserAvatar = ({ id }) => <UserNameTagComponent id={id} />;

  const portalUsersTemplate = useCallback(
    () => (
      <GridComponent
        ref={dataGrid}
        dataSource={portalUsersService}
        editSettings={editSettings}
        actionBegin={actionBegin}
        filterSettings={{
          type: "Menu",
        }}
        toolbar={toolbarOptions}
        allowFiltering
        allowSorting
        allowPaging
        allowResizing
        height="100%"
        toolbarClick={toolbarClick}
        className={css.tableWrapper}
        childGrid={childGrid}
        allowGrouping={false}
        rowHeight={48}
        pageSettings={pageSettings}
        queryCellInfo={queryCellInfo}
        customGridStyle
        rowSelected={() => {
          usersRowStateSet(true);
        }}
        rowDeselected={() => {
          usersRowStateSet(false);
        }}
      >
        <ColumnsDirective>
          <ColumnDirective
            type="string"
            field="fullName"
            headerText={t("Username")}
            width="150"
            textAlign="Left"
            editType="dropdownedit"
            template={getUserAvatar}
          />
          <ColumnDirective
            type="string"
            field="email"
            headerText={t("E-mail ID")}
            width="180"
            textAlign="Left"
            editType="dropdownedit"
          />
          <ColumnDirective
            type="string"
            field="userName"
            headerText={t("User ID")}
            width="180"
            textAlign="Left"
            editType="dropdownedit"
          />
          <ColumnDirective
            type="string"
            field="designation"
            headerText={t("Designation")}
            width="150"
            textAlign="Left"
            editType="dropdownedit"
          />
          {/* <ColumnDirective
            field="department"
            headerText={t("Department")}
            width="150"
            textAlign="Left"
            editType="dropdownedit"
          /> */}
          <ColumnDirective field="created" headerText={t("Added on")} width="150" type="date" />
          <ColumnDirective field="status" headerText={t("Status")} width="150" type="string" />
          <ColumnDirective headerText={t("Org")} width="120" textAlign="Left" field="companyName" type="string" />
          <ColumnDirective field="role" headerText={t("Portal Role")} width="120" textAlign="Center" type="string" />
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Page,
            DetailRow,
            Toolbar,
            Edit,
            Filter,
            Sort,
            Group,
            ColumnChooser,
            Selection,
            ColumnChooser,
            VirtualScroll,
          ]}
        />
      </GridComponent>
    ),
    [portalRoles],
  );

  return (
    <>
      {!portalSettingInfo?.portalUsers?.isVisible ? (
        <Forbidden />
      ) : (
        <div className={css.controlPane}>
          <AddUserToPortal isVisible={openAddUserModal} setOpenAddUserModal={setOpenAddUserModal} />
          {deactivateUserModal()}
          {editUserModal()}
          {warningModal()}
          {portalRoles.length > 0 && portalUsersTemplate()}
        </div>
      )}
    </>
  );
}
export default PortalUsersList;
